import React from "react";
import { Link } from "react-router-dom";
import { EyeOutlined, EditOutlined } from "@ant-design/icons";
import { Row, Card, Tag, Button } from "antd";

import DownloadBtn from "../downloadbtn";
import ItemTag from "../itemtag";
import DynamicIcon from "../DynamicIcon";
import FileLoader from "../FileLoader";
import { formatDate } from "../../utils";
import { Dictionary } from "../../interfaces";
import { ItemFile } from "../../reducers/items";

// import { useWhyDidYouUpdate } from "../../hooks/useWhyDidYouUpdate";

interface Item {
  id: string;
  thumbUrl: string;
  name: string;
  icon: string;
  publishDate: string;
  can_edit: boolean;
  edit_link: string;
  tags: Array<string>;
  markets: Array<string>;
  files: Array<ItemFile>;
}

interface Props {
  item: Item;
  downloadLabel: string;
  editLabel: string;
  tagById: Dictionary<any>;
  marketById: Dictionary<any>;
  onItemSelect: Function;
  onTagClicked: Function;
}

const ThumbItem = (props: Props) => {
  const {
    item,
    tagById,
    marketById,
    downloadLabel,
    editLabel,
    onItemSelect,
    onTagClicked
  } = props;

  const {
    id,
    name,
    thumbUrl,
    icon,
    publishDate,
    tags,
    markets,
    files,
    can_edit,
    edit_link
  } = item;

  // useWhyDidYouUpdate("ThumbItem", props);
  // console.log("thumb render");

  const selectItem = () => {
    onItemSelect(item);
  };

  return (
    <Card
      className="thumb"
      title={
        <div className="card-title">
          <DynamicIcon type={icon} /> <p>{name}</p>
        </div>
      }
      style={{ display: "block" }}
      bodyStyle={{ padding: 0 }}
    >
      <Link to={`/details/${id}`}>
        <div className="custom-image" onClick={selectItem}>
          {thumbUrl && thumbUrl !== "" ? (
            <FileLoader fileName={name} fileUrl={thumbUrl} type="tag" />
          ) : (
            <div className="no-preview">
              <DynamicIcon type={icon} />
            </div>
          )}
          <Row className="img-overlay" align="middle" justify="center">
            <EyeOutlined className="icon" />
          </Row>
        </div>
      </Link>
      <div className="custom-card">
        {/* <div className="guid">
          <span>guid: </span>
          {guid}
        </div> */}
        <div className="details-bar">
          <h4>{formatDate(publishDate)}</h4>
          <div>
            {marketById &&
              markets.map((market) => {
                return marketById[market] !== undefined ? (
                  <Tag
                    className="item-tag"
                    key={market}
                    id={market}
                    color="#4eb1d5"
                  >
                    {marketById[market].name}
                  </Tag>
                ) : (
                  console.log("market non presente nella lista ", market)
                );
              })}
          </div>
        </div>
        {tagById &&
          tags.map((tag) => {
            return tagById[tag] !== undefined ? (
              <ItemTag
                key={tag}
                id={tag}
                itemId={id}
                name={tagById[tag].name}
                tagClicked={onTagClicked}
              />
            ) : (
              console.log("tag non presente nella lista ", tag)
            );
          })}
        <div className="btns-wrapper">
          <DownloadBtn
            direction="topCenter"
            clsName="btn-white"
            files={files}
            itemId={id}
            label={downloadLabel}
          />
          {can_edit && (
            <Button
              className="edit-btn btn-white"
              title={editLabel}
              href={edit_link}
              target="_blank"
            >
              <EditOutlined />
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
};

export default React.memo<Props>(ThumbItem);
